/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ result: NonNullable<unknown> }} Jobs_Toast_DoneInputs */

const cs_jobs_toast_done = /** @type {(inputs: Jobs_Toast_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hotovo: ${i?.result}`)
};

const en_jobs_toast_done = /** @type {(inputs: Jobs_Toast_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Done: ${i?.result}`)
};

/**
* | output |
* | --- |
* | "Done: {result}" |
*
* @param {Jobs_Toast_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_toast_done = /** @type {((inputs: Jobs_Toast_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Toast_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_toast_done(inputs)
	return cs_jobs_toast_done(inputs)
});